import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { ApplicationComponent } from './application/application.component';
import { ConnectorComponent } from './connector/connector.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuardService } from './auth-guard.service';
import { MessageComponent } from './message/message.component';
import { MessagesComponent } from './messages/messages.component';
import { OverviewComponent } from './overview/overview.component';
import { ResellerViewComponent } from './reseller-view/reseller-view.component';
import { MonthlyActiveUserComponent } from './monthly-active-user/monthly-active-user.component';
import { ResellermessagecountComponent } from './resellermessagecount/resellermessagecount.component';
import { WhatsappPricingComponent } from './whatsapp-pricing/whatsapp-pricing.component';
import { WhatsappEmbeddedSignupComponent } from './whatsapp-embedded-signup/whatsapp-embedded-signup.component';
const routes: Routes = [{
    path: 'messages',
    canActivate: [AuthGuardService],
    component: MessagesComponent,
    data: { 
        title: 'Messages'
    }
},
{
    path: 'message',
    canActivate: [AuthGuardService],
    component: MessageComponent,
    data: {
        title: 'Message'
    }
},
{
    path: 'overview',
    canActivate: [AuthGuardService],
    component: OverviewComponent,
    data: {
        title: 'Overview'
    }
},
{
    path: 'reseller',
    canActivate: [AuthGuardService],
    component: ResellerViewComponent,
    data: {
        title: 'Reseller'
    }
},

{
    path: 'resellermessage',
    canActivate: [AuthGuardService],
    component: ResellermessagecountComponent,
    data: {
        title: 'Resellermessage'
    }
},

{
    path: 'monthlyactiveuser',
    canActivate: [AuthGuardService],
    component: MonthlyActiveUserComponent,
    data: {
        title: 'Monthlyactiveuser'
    }
},

{
		path: 'application',
		canActivate: [AuthGuardService],
		component: ApplicationComponent,
		data: {
			title: 'Application'
		}
	},{
		path: 'connectors',
		canActivate: [AuthGuardService],
		component: ConnectorComponent,
		data: {
			title: 'Connector'
		}
	},
	{
		path: 'whatsapppricing',
		canActivate: [AuthGuardService],
		component: WhatsappPricingComponent,
		data: {
			title: 'WhatsApppricing'
		}
	},	{
		path: 'embeddedsignup',
		canActivate: [AuthGuardService],
		component: WhatsappEmbeddedSignupComponent,
		data: {
			title: 'Whatsappembeddedsignup'
		}
	},{
		path: 'dashboard',
		canActivate: [AuthGuardService],
		component: DashboardComponent,
		data: {
			title: 'Dashboard'
		}
	},{
		path: 'application/:id',
		canActivate: [AuthGuardService],
		redirectTo: '/application', pathMatch: 'full'
	},{
		path: 'connectors/:id',
		canActivate: [AuthGuardService],
		redirectTo: '/connectors', pathMatch: 'full'
	},{
		path: 'dashboard/:id',
		canActivate: [AuthGuardService],
		redirectTo: '/dashboard', pathMatch: 'full'
	},{
		path: ':id',
		redirectTo: '/', pathMatch: 'full'
	},{
		path: '**',
		component: LayoutComponent
	}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
